module.exports = __webpack_public_path__ + "img/BioDF-textlogo.6dfc97ff.png";